<template>
    <svg viewBox="0 0 24 24" width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 10.248C4 5.82977 7.58172 2.24805 12 2.24805C16.4183 2.24805 20 5.82977 20 10.248C20 12.7222 18.9059 15.0068 17.6306 16.8421C16.3478 18.6883 14.8159 20.1742 13.7922 21.0718C12.7584 21.9782 11.2416 21.9782 10.2078 21.0718C9.18407 20.1742 7.65218 18.6883 6.36935 16.8421C5.09414 15.0068 4 12.7222 4 10.248ZM11.9978 12.748C13.3785 12.748 14.4978 11.6287 14.4978 10.248C14.4978 8.86734 13.3785 7.74805 11.9978 7.74805C10.6171 7.74805 9.4978 8.86734 9.4978 10.248C9.4978 11.6287 10.6171 12.748 11.9978 12.748Z"
            fill="black"
        />
    </svg>
</template>
